import request from '../request'

/**
 * 获取文件每页的地址和校审批注列表
 * @param {string|number} pageId - 页码/页面ID
 */
export function fetchDesignResultAuditMarkupComments({ fileId, pageId }) {
    return request({
        url: `/project-service/cosys/design/result/audit/markup/comments`,
        method: 'GET',
        params: { fileId, pageId }
    })
}

/**
 * 获取校审批注文件版本列表
 * @param {string|number} auditId - 校审记录ID
 */
export function fetchDesignResultAuditMarkupFiles(auditId) {
    return request({
        url: `/project-service/cosys/design/result/audit/markup/files/${auditId}`,
        method: 'GET'
    })
}

/**
 * 根据版本号查询校审批注文件列表
 * @param {string|number} auditId - 校审记录ID
 * @param {string|number} versionNo - 版本号
 */
export function fetchDesignResultAuditMarkupFilesByVersion(auditId, versionNo) {
    return request({
        url: `/project-service/cosys/design/result/audit/markup/files/${auditId}/version/${versionNo}`,
        method: 'GET'
    })
}
/**
 * 获取pdf
 */
export function queryFileById(id) {
    return request({
        url: `/common-service/file/query/${id}`,
        method: 'GET',
    })
}

/**
 * 批量新增校审批注
 * @param {Object} data - 批注数据列表
 */
export function addDesignResultAuditMarkupComment(data) {
    return request({
        url: '/project-service/cosys/design/result/audit/markup/comment/add',
        method: 'POST',
        data
    })
}

/**
 * 批量回复校审批注
 * @param {Object} data - 回复数据列表
 */
export function replyDesignResultAuditMarkupComment(data) {
    return request({
        url: '/project-service/cosys/design/result/audit/markup/comment/reply',
        method: 'POST',
        data
    })
}

/**
 * 获取校审记录详情
 * @param {string|number} id - 校审记录ID
 */
export function fetchDesignResultAuditDetail(id) {
    return request({
        url: `/project-service/cosys/design/result/audit/detail/${id}`,
        method: 'GET'
    })
}


/**
 * 校审批注：上传新版本附件并拆分PDF
 * @param {string|number} auditId - 校审记录ID
 * @param {FormData} data - 上传的文件及相关信息
 */
export function uploadDesignResultAuditMarkup(auditId, data) {
    return request({
        url: `/project-service/cosys/design/result/audit/markup/upload`,
        method: 'POST',
        data
    })
}

/**
 * 重新发起校审审批（仅Cancel/Reject状态可操作）
 * @param {string|number} auditId - 校审记录ID
 * @param {object} data - 提交数据
 */
export function resubmitDesignResultAudit(auditId, data) {
    return request({
        url: `/project-service/cosys/design/result/resubmit`,
        method: 'POST',
        data
    })
}

/**
 * 删除设计成果
 * @param {string|number} id - 成果ID
 */
export function delDesignResult(id) {
    return request({
        url: `/project-service/cosys/design/result/del/${id}`,
        method: 'GET'
    })
}


/**
 * 根据auditId获取文件批注统计信息
 * @param {string} auditId - 审核ID
 */
export function getDesignResultAuditMarkupStatistics(auditId) {
    return request({
        url: `/project-service/cosys/design/result/audit/markup/statistics/${auditId}`,
        method: 'GET'
    })
}


/**
 * 获取阶段任务概要
 * @param {string|number} phaseId - 阶段任务ID
 */
export function fetchPrjTaskPhaseSummary(phaseId) {
    return request({
        url: `/project-service/cosys/prj/task/phase/summary/${phaseId}`,
        method: 'GET'
    })
}
/**
 * 删除校审批注
 * @param {string} id - 校审批注id(路径参数)
 */
export function deleteAuditMarkupComment(id) {
    return request({
        url: `/project-service/cosys/design/result/audit/markup/comment/delete/${id}`,
        method: 'POST'
    })
}
